import { Status } from '../../Constants/Consts';
import { DDCheckList } from '../../types/DataDD/DataDD';

export function buildBasePayload(firstTask: DDCheckList, uuid: string): Partial<DDCheckList> {
    return {
        projectNumber: firstTask.projectNumber,
        disciplineId: firstTask.disciplineId,
        dd01: firstTask.dd01,
        inspectionVersion: null,
        ctUuid: uuid,
        statusId: Status.Open,
        listOrder: 0,
        notSync: !navigator.onLine,
        creation: true,
        drilldownTypeId: firstTask.drilldownTypeId,
        isArchived: false,
        isAdhocTask: true,
    };
}
